<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
        <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
          <Fields
            v-bind="{fields, object: formData, errors: formErrors}"
            />

          <v-btn type="submit" color="primary">Zapisz</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {updateRunnerTrainer} from './api'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import _ from 'lodash'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    runnerData: {
      type: Object
    }
  },
  computed: {
    fields () {
      return [
        {comp: 'checkbox', id: 'get_tshirt', label: 'Otrzymał koszulkę:'},
        {comp: 'checkbox', id: 'get_card', label: 'Otrzymał kartę:'}
      ]
    },
    message () {
      return 'Konto zawodnika zostało edytowane.'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.runnerData)
  },
  methods: {
    submit (data) {
      return updateRunnerTrainer(this.$route.params.id, data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerTrainerUpdateForm.vue